<template>
	<div class="footer">
		<div v-if="lang !== 'ko'" class="sns">
			<a href="https://www.instagram.com/TodoMath/" target="_blank"><img src="@/assets/footer/icon-instagram.svg"/></a>
			<a href="https://www.facebook.com/TodoMath/" target="_blank"><img src="@/assets/footer/icon-facebook.svg"/> </a>
			<a href="https://twitter.com/EnumaApps" target="_blank"><img src="@/assets/footer/icon-twitter.svg"/> </a>
			<a href="https://www.youtube.com/user/LocoMotiveLabs" target="_blank"><img src="@/assets/footer/icon-youtube.svg"/> </a>
			<!-- <a href="https://medium.com/@TodoMath" target="_blank"><img src="@/assets/footer/icon-blog.svg"/> <span>{{l10.All_Footer_SNSbutton_Buttonname4}}</span></a> -->
		</div>
		<div v-if="lang === 'ko'" class="sns">
			<a href="https://www.instagram.com/todomath_kr/?hl=ko" target="_blank"><img src="@/assets/footer/icon-instagram.svg"/> </a>
			<a href="https://www.facebook.com/todomathkr/" target="_blank"><img src="@/assets/footer/icon-facebook.svg"/> </a>
			<a href="https://twitter.com/EnumaApps" target="_blank"><img src="@/assets/footer/icon-twitter.svg"/> </a>
			<a href="https://www.youtube.com/channel/UC4RVkbteW8dY4r8ae-YGEIg/featured" target="_blank"><img src="@/assets/footer/icon-youtube.svg"/> </a>

		</div>
		<div>
			<span>Language : </span>
			<select v-model="changedLanguage" v-on:change="changLanguage()">
				<option value="en">{{l10.En_Footer_Dropdownmenu_Language1}}</option>
				<option value="ko">{{l10.Kr_Footer_Dropdownmenu_Language2}}</option>
				<option value="cn">{{l10.Cn_Footer_Dropdownmenu_Language3}}</option>
				<option value="ja">{{l10.Jp_Footer_Dropdownmenu_Language4}}</option>
			</select>
		</div>
		<div>
			<span>ⓒ 2018 Enuma, Inc.</span> <span v-html="l10.All_Footer_Copyright"></span>
		</div>

		<div class="policy">
			<span class='footerlink' @click='handleLinkClick("tos")'>{{l10.All_Footer_Menubutton_Buttonname1}}</span><span>|</span>
			<span class='footerlink' @click='handleLinkClick("policy")'>{{l10.All_Footer_Menubutton_Buttonname2}}</span><span>|</span>
			<!--	
			<a href="http://enuma.com/tos/" target="_blank">{{l10.All_Footer_Menubutton_Buttonname1}}</a><span>|</span>
			<a href="http://enuma.com/policy/" target="_blank">{{l10.All_Footer_Menubutton_Buttonname2}}</a><span>|</span>
			-->
			<a href="http://enuma.com/legal/" target="_blank">{{l10.All_Footer_Menubutton_Buttonname3}}</a><span>|</span>
			<router-link to="/help/contact">{{l10.All_Footer_Menubutton_Buttonname4}}</router-link>
			<!-- <router-link to="/help">{{l10.All_Footer_Menubutton_Buttonname5}}</router-link> -->


		</div>
		<div class="info" v-if="lang == 'ko'" >

				<span>에누마코리아(주)&nbsp;&nbsp; 대표 전유택</span>
				<p class="item"><span>사업자등록번호</span>&nbsp;&nbsp;&nbsp;&nbsp;883-86-00976</p>
				<p class="item"><span>주소</span>&nbsp;&nbsp;&nbsp;&nbsp;서울특별시 성동구 뚝섬로1나길 5, G301호 (성수동 1가, 헤이그라운드)</p>
				<p class="item"><span>대표전화</span>&nbsp;&nbsp;&nbsp;&nbsp;02-462-9701</p>


		</div>


	</div>

</template>
<script>
import VueCookies from 'vue-cookies'
export default {
  name: 'Footer',
  data () {
			const text = require('@/text/common/footer.js').default;
			const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];
			const lang = this.$store.state.lang;
	    return {
				l10:l10n,
				changedLanguage:lang,
				lang:lang
	    }
	},
	methods:{
		changLanguage(){
			this.$store.commit('setLanguage',this.changedLanguage);
			
			if(this.$route.fullPath.indexOf('help') != -1 && this.$route.fullPath.indexOf('help/contact') == -1){
				window.location = '/help/faqs';
			} else if(this.$route.fullPath.indexOf('l=cn') != -1) {
				window.location = this.$route.fullPath.replace('l=cn', '')
			} else if(this.$route.fullPath.indexOf('appurl=http') != -1 || this.$route.fullPath.indexOf('appver=') != -1) {
				this.$router.replace('/')
				window.location.reload()
			} else {
				window.location.reload()
			}
			return true
		},
		handleLinkClick(target) {
			var url = ''
			if (this.lang == 'cn') {
				if (target == 'tos') {
					url = 'https://english.enuma.cn/cn/tos'
				} else if (target == 'policy') {
					url = 'https://english.enuma.cn/cn/privacy'
				}
			} else {
				url = 'https://enuma.com/' + target
			}

			if (url != '') window.open(url, '_blank')
		}
	}
}
</script>
<style  scoped>
.footerlink {
	font-size: 22px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.7px;
    color: #999999;
	margin-left: 21px;
	margin-right: 21px;
}

.policy span:first-of-type {
	margin-left: 0px;
}
.footer{
	max-width:720px;
	margin:0 auto;

	overflow: hidden;
	min-height:326px;
	padding: 0 35px;
	padding-top:50px;

	font-size: 22px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -0.7px;
	text-align: left;
	color: #bebebe;

}


.footer select{
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.7px;
  color: #999999;

  width:120px;
}

a{
	font-size: 22px;
		font-weight: normal;
		font-style: normal;
		font-stretch: normal;
		line-height: normal;
		letter-spacing: -0.7px;
		color: #999999;
}

.sns a img{
	width:43px;
	height: 43px;
}
.sns>a {
	display: inline-block;
}
.sns>a~a{
	margin-left:48px;
}
.sns>a span{
	margin-left:6px;
	font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #999999;
}
.policy a~span{
	margin-left: 21px;
}
.policy span~a{
	margin-left: 21px;
}
.footer>div:nth-child(2){
	margin-top:37px;
}
.footer>div:nth-child(3){
	margin-top:40px;
}
.footer>div:nth-child(4){
	margin-top:12px;
}
.info{
	padding-bottom: 53px;
	padding-top: 45px;
	border-top: 1px solid #f5f5f5;
	margin-top:53px;
	color:#999999
}
.item{
	display: block;
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.7px;
	margin-top:12px;
}
.item:first-of-type{
	margin-top:40px;
}

.item>span{
	color: #bebebe;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/FooterMobile.vue